import { render, staticRenderFns } from "./Phone2.vue?vue&type=template&id=5b8d893c&"
import script from "./Phone2.vue?vue&type=script&lang=js&"
export * from "./Phone2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports